import React, { useState } from "react";
import "./App.scss";
import Header from "./components/Header";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import BlogDump from "./components/Blog-Dump/BlogDump";
import Project from "./components/Projects/Project";
import speaker from "./Speaker.png";

import Resumepdf from "./components/Resume/Resumepdf";

function App() {
  // const Footer=({location: {pathname}})=>{
  //   return pathname !== "/blogs" && <div className="footer"/>;

  // };

  return (
    <Router>
      <div className="App">
        <Header />
        <div className="container">
          <div className="wrapper">
            <div className="home">
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/projects" component={Projects} />
                <Route exact path="/blogs" component={Blogs} />
                <Route exact path="/resume" component={Resume} />
              </Switch>
            </div>
          </div>
        </div>
        <div className="footer" />
      </div>
    </Router>
  );
}

function Projects() {
  return (
    <div>
      <Project />
    </div>
  );
}

function Blogs() {
  return (
    <div>
      {" "}
      <BlogDump />{" "}
    </div>
  );
}

function Resume() {
  return (
    <div>
      <Resumepdf />
    </div>
  );
}

function Home() {
  return (
    <div className="container">
      <div className="wrapper">
        <div className="speaker">
          {/* Button comes here- make a func for click audio */}
        </div>
        <div className="information">*rotate your device*</div>
        <h5>
          Hi there, I am <b>Aishani</b> <br /> I help companies build their
          online presence.
        </h5>
      
      </div>
    </div>
  );
}
export default App;
